export default __webpack_public_path__ + "static/media/portadavideoconfiguracion5.2b06616c.png";